export default "__VITE_ASSET__DbicDUwH__"